import { Drawer, Theme, createStyles } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react-lite';
import React, { ReactNode } from 'react';

export enum IAnchorType {
    LEFT = 'left',
    RIGHT = 'right',
}

const useStyles: any = makeStyles((theme: Theme) =>
    createStyles({
        applicationDrawer: {
            '& .MuiDrawer-paper': {
                [theme.breakpoints.up('md')]: {
                    width: '70%',
                    paddingLeft: '40px',
                    paddingRight: '40px',
                },
                [theme.breakpoints.down('md')]: {
                    width: '95%',
                },
            },
        },
    }),
);

export const AdminDrawer: React.FC<{
    type: IAnchorType;
    children: ReactNode;
    open: boolean;
    onClose: () => void;
}> = observer(({ type, children, open, onClose }) => {
    const classes = useStyles();
    return (
        <>
            <Drawer
                anchor={type}
                open={open}
                onClose={onClose}
                className={classes.applicationDrawer}
            >
                {children}
            </Drawer>
        </>
    );
});
